import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SortCandidatesModule } from '@shared/sort-candidates/sort-candidates.module';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoEditorModule } from 'mojo-editor';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { FeatureFlagsModule } from 'mojo-feature-flags';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { MojoSelectModule } from 'mojo-select';

import { MaterialModule } from '@app/material/material.module';
import { CandidatesComponentsModule } from '@app/modules/candidates/components';
import { HiringManagerSubmitModalComponent } from '@modules/assigns/components/hiring-manager-submit-modal/hiring-manager-submit-modal.component';
import { AssignedCandidateContainerComponent } from '@modules/assigns/containers';
import { AssignsEffects } from '@modules/assigns/store';
import { HiringManagerModule } from '@modules/hiring-manager/hiring-manager.module';
import { AssociationConfigurationService, SharedModule } from '@shared';
import { CandidateModule } from '@shared/candidate/candidate.module';
import { CheckboxModule } from '@shared/checkbox';
import { CollectionModule } from '@shared/collection';
import { FeedbackModule } from '@shared/feedback/feedback.module';
import { MatchesPhasesModule } from '@shared/matches-phases/matches-phases.module';
import { SideNavModule } from '@shared/side-nav/side-nav.module';
import { StatusModule } from '@shared/status/status.module';
import { StepperModule } from '@shared/stepper/stepper.module';

import { AssignConfig } from './assign.abstract.config';
import { assignConfig } from './assign.config';
import { AssociationReasonsComponent } from './components/candidate-association-reasons/candidate-association-reasons.component';
import { ChangeCandidateStatusModalComponent } from './components/change-candidate-status-modal/change-candidate-status-modal.component';
import { JobAssignCollectionHeaderComponent } from './components/job-assign-collection-header/job-assign-collection-header.component';
import { MatchedCandidateButtonsComponent } from './components/matched-candidate-buttons/matched-candidate-buttons.component';
import { StatusesAssignSelectComponent } from './components/statuses-assign-select/statuses-assign-select.component';
import {
  AssignedJobContainerComponent,
  CandidateAssignsContainerComponent,
  JobAssignsContainerComponent,
} from './containers';
import { AssociationLabelComponent } from './containers/association-label/association-label.component';
import { AssignsButtonsModule } from './containers/buttons+/assigns-buttons.module';
import { assignsReducer } from './store/assigns.reducer';
import { HiringManagerStatusesComponent } from './components/hiring-manager-statuses/hiring-manager-statuses.component';

const components = [
  JobAssignCollectionHeaderComponent,
  StatusesAssignSelectComponent,
  MatchedCandidateButtonsComponent,
  ChangeCandidateStatusModalComponent,
  AssociationReasonsComponent,
  HiringManagerSubmitModalComponent,
];

const containers = [
  JobAssignsContainerComponent,
  CandidateAssignsContainerComponent,
  AssignedCandidateContainerComponent,
  AssignedJobContainerComponent,
  AssociationLabelComponent,
];

@NgModule({
  declarations: [...containers, ...components, HiringManagerStatusesComponent],
  imports: [
    AssignsButtonsModule,
    CandidateModule,
    CandidatesComponentsModule,
    CdkStepperModule,
    CollectionModule,
    EffectsModule.forFeature([AssignsEffects]),
    StoreModule.forFeature('candidatePage', assignsReducer),
    FeedbackModule,
    FeatureFlagsModule,
    MaterialModule,
    MatFormFieldModule,
    MatSelectModule,
    MojoAvatarModule,
    MojoFeatureExtensionsModule,
    MojoPrivilegesModule,
    MojoSelectModule,
    SharedModule,
    SideNavModule,
    StatusModule,
    StepperModule,
    CheckboxModule,
    HiringManagerModule,
    MatchesPhasesModule,
    SortCandidatesModule,
    MatRadioModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
  ],
  exports: [...containers, AssignsButtonsModule, MatchedCandidateButtonsComponent],
  providers: [
    {
      provide: AssignConfig,
      useValue: assignConfig,
    },
    AssociationConfigurationService,
  ],
})
export class AssignModule {}
